<div class="header-row">
	<div class="column title" [attr.data-exportable]="exportMode() ? 'true' : null">
		<h2>Overzicht</h2>
		<div class="subtitle">% aanwezigheid laatste maand</div>
	</div>
	<app-weergave-optie
		label=""
		param="aanwezigheiduitsplitsing"
		[value]="aanwezigheiduitsplitsing()"
		[enum]="AanwezigheidUitsplitsing"
		[filter]="uitsplitsingFilter"
		data-princexml-ignore
		data-html2canvas-ignore
	></app-weergave-optie>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="uitsplitsingTooltip"></app-icon>
	</div>
</div>
<ng-template #uitsplitsingTooltip>
	<div class="tooltip">
		<h4>Overzicht aanwezigheid</h4>
		<p>
			Leerlingen, klassen of vakken worden uitgesplitst in drie interventielagen van het piramideraamwerk (MD-MTSS-model), op basis van hun
			aanwezigheidspercentages. De lijsten zijn gesorteerd op aanwezigheid in de laatste maand.
		</p>
		<ol>
			@for (laag of interventielagen; track laag) {
				<li>{{ laag }}: {{ interventielaagDetails[laag] }}</li>
			}
		</ol>
	</div>
</ng-template>
<div class="row">
	@for (laag of interventielagen; track laag) {
		<app-interventielaag-list-panel
			[laag]="laag"
			[maanden]="laatsteMaanden()"
			[sortMonth]="sortMonth()"
			[pageFilter]="pageFilter()"
			[laagFilter]="laagFilter[laag]()"
			(totalChanged)="totals[laag].next($event)"
			[exportMode]="exportMode()"
			[attr.data-exportable]="exportMode() ? 'true' : null"
		></app-interventielaag-list-panel>
	}
</div>
